import { RouteEnum } from 'pro/config/routers';
import { transToDynamicPath } from 'base/utils/trans-path';

export type navConfigItem = {
    name: string;
    url: string;
    children?: string[];
    key?: string;
    condition?: string;
    showPoint?: boolean; // 展示小红点
};

export const navConfig: navConfigItem[] = [
    {
        name: 'web_account_profile_title',
        url: RouteEnum.PROFILE,
    },
    {
        name: 'web_account_address_title',
        url: RouteEnum.ADDRESS_BOOK,
    },
    {
        name: 'web_account_orders_title',
        url: RouteEnum.ORDERS,
        children: [
            transToDynamicPath(RouteEnum.ORDER),
            transToDynamicPath(RouteEnum.REVIEW),
            transToDynamicPath(RouteEnum.REFUND),
            transToDynamicPath(RouteEnum.REFUND_PROGRESS),
            transToDynamicPath(RouteEnum.TRACK),
            transToDynamicPath(RouteEnum.PACKAGE),
        ]
    },
    {
        name: 'web_account_coupons_title',
        url: RouteEnum.COUPONS,
        condition: 'notDealer'
    },
    {
        name: 'web_account_points_title',
        url: RouteEnum.POINTS_MALL,
        condition: 'notDealer'
    },
    {
        key: 'message',
        name: 'web_account_message_title',
        url: RouteEnum.MESSAGE_CENTER,
        showPoint: false
    },
    {
        name: 'web_account_security_title',
        url: RouteEnum.SECURITY,
    },
    {
        name: 'web_refer_friend_page_title',
        url: RouteEnum.REFER_A_FRIEND,
        condition: 'showReferrer'
    },
];